export const SET_KILLSWITCHES = 'SET_KILLSWITCHES';
